var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lingos-info"},[_c('img',{attrs:{"src":"/images/activities/lingo.png","alt":"Lingos"}}),_vm._v(" +"+_vm._s(_vm.lingos)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }